import { resolveImagePath } from "@/utils/imageMap.ts";

export function Hero() {
  const heroBg = resolveImagePath("/images/hero-banner.jpg");

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ minHeight: "464px" }}
    >
      <img
        src={heroBg}
        alt="IMG_3403.JPG"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
      />
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4" style={{ minHeight: "464px" }}>
        <p className="font-heading text-[#1e2025] text-lg md:text-xl leading-snug">
          Start Your Soaring Adventure with Merlin Aviation.
        </p>
        <p className="font-heading text-[#1e2025] text-lg md:text-xl leading-snug">
          Glider rides and flight training in Moriarty,NM
        </p>
      </div>
    </section>
  );
}
